/* F2 Versand-Countdown: rechnet in Europe/Berlin (Sommer- und Winterzeit ueber Intl).
   Werktag = Montag bis Freitag und nicht in der Feiertagsliste (JJJJ-MM-TT, kommagetrennt). */
(function () {
  if (customElements.get('mse-versand-countdown')) return;

  var fmt = new Intl.DateTimeFormat('de-DE', {
    timeZone: 'Europe/Berlin',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', weekday: 'short', hourCycle: 'h23'
  });

  function berlinNow() {
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return p;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  class MseVersandCountdown extends HTMLElement {
    connectedCallback() {
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      var out = this.querySelector('[data-dispatch-text]');
      if (!out) return;
      var p = berlinNow();
      var iso = p.year + '-' + p.month + '-' + p.day;
      var feiertage = (this.dataset.feiertage || '').split(',');
      var wochenende = ['Sa', 'So'].indexOf(p.weekday.replace('.', '')) > -1;
      var werktag = !wochenende && feiertage.indexOf(iso) < 0;
      var schluss = (+this.dataset.stunde || 12) * 60 + (+this.dataset.minute || 0);
      var rest = schluss - ((+p.hour) * 60 + (+p.minute));

      if (werktag && rest > 0) {
        var h = Math.floor(rest / 60), m = rest % 60;
        var dauer = '<b>' + (h ? h + ' Std. ' : '') + m + ' Min.</b>';
        out.innerHTML = esc(this.dataset.textHeute || '').replace('[countdown]', dauer);
      } else {
        out.textContent = this.dataset.textSpaeter || '';
      }
      this.classList.add('is-ready');
    }
  }

  customElements.define('mse-versand-countdown', MseVersandCountdown);

  /* Variantenwechsel: Block aus der neu gerenderten Section uebernehmen (verfuegbar oder ausverkauft) */
  function init() {
    if (window.mseDispatchSub || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.mseDispatchSub = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var id = 'MseDispatch-' + event.data.sectionId;
      var source = event.data.html.getElementById(id);
      var target = document.getElementById(id);
      if (!source || !target) return;
      target.replaceWith(document.importNode(source, true));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
